import { React, useContext, useState } from 'react'
import Popup from './Popup'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { BsPlusLg } from 'react-icons/bs'
import { AiOutlineMinus } from 'react-icons/ai'
import { AccordionContext, useAccordionButton, Accordion, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
function ContextAwareToggle({ children, eventKey, callback }) {


    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    );

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <button
            type="button"
            onClick={decoratedOnClick}
            className="acc-toggler"
        >
            {isCurrentEventKey ? <AiOutlineMinus /> : <BsPlusLg />}
        </button>
    );
}

const scrollTopTop = (changeState) => {
    changeState(1)
    window.scrollTo(0, 0)
}


export default function Iro() {

    const [state, setstate] = useState(0)

    return (
        <>

            {state == 1 && <Popup passState={setstate} />}

            <div className="container mt-5">
                <div className="d-flex justify-content-center flex-column pb-5">
                    <h1 className="h1 text-center">IRO</h1>
                    <p className="text-center heading-desc">Buy Reaper Token with BUSD</p>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="card " style={{ overflow: "hidden", borderRadius: "7px" }}>
                            <div className="card-body p-0">
                                <div className="g-btn rounded-0 py-3 justify-content-between">
                                    <p className="mb-0 h6">Initial Reaper Offering</p>
                                    <AiOutlineQuestionCircle className="fs-4" />
                                </div>
                                <div className="p-3 px-lg-4 px-2">
                                    <div className=" d-flex justify-content-center align-items-center border-bottom py-4">
                                        <button className="btn-faded px-4 text-uppercase">buy token</button>
                                    </div>
                                    <div className="d-flex justify-content-between py-1 mt-3">
                                        <span className="text-faded text-uppercase ">Additional fee:</span>
                                        <span className=" text-uppercase text-end">0%</span>
                                    </div>
                                    <div className="d-flex justify-content-between py-1">
                                        <span className="text-faded text-uppercase ">Total committed:</span>
                                        <span className=" text-uppercase text-end">0%</span>
                                    </div>
                                    <div className="d-flex justify-content-between py-1">
                                        <span className="text-faded text-uppercase ">Funds to raise:</span>
                                        <span className=" text-uppercase text-end">$1,000,000</span>
                                    </div>
                                    <div className="d-flex justify-content-between py-1 border-bottom pb-3 mb-3">
                                        <span className="text-faded text-uppercase ">Price per reaper (yrp) :</span>
                                        <span className=" text-uppercase text-end">$0.2</span>
                                    </div>
                                    <div className="d-flex justify-content-between flex-lg-row flex-column align-items-center py-3 mx-0 ">
                                        <div className=" d-flex flex-column align-items-center ps-0 w-100 pb-lg-0 pb-3">
                                            <div className="d-flex">
                                                <span className="text-faded text-uppercase ">Date</span>
                                                <span className="text-faded text-uppercase ps-3">01.10.22</span>
                                            </div>
                                            <button className="g-btn px-5 mt-2 text-uppercase col-lg-7 col-12">Claim</button>
                                            <div className="d-flex">
                                                <span className="text-faded text-uppercase pt-2">AMOUNT : 10214 YRP</span>
                                            </div>
                                        </div>
                                        <span className="d-lg-none d-flex border-bottom mb-3 col-12"></span>
                                        <div className=" d-flex flex-column align-items-center ps-0 w-100 pb-lg-0 pb-3">
                                            <div className="d-flex">
                                                <span className="text-faded text-uppercase ">Date</span>
                                                <span className="text-faded text-uppercase ps-3">01.10.22</span>
                                            </div>
                                            <button className="g-btn px-5 mt-2 text-uppercase col-lg-7 col-12">Claim</button>
                                            <div className="d-flex">
                                                <span className="text-faded text-uppercase pt-2">AMOUNT : 10214 YRP</span>
                                            </div>
                                        </div>
                                        <span className="d-lg-none d-flex border-bottom mb-3 col-12"></span>

                                        <div className=" d-flex flex-column align-items-center ps-0 w-100 pb-lg-0 pb-3">
                                            <div className="d-flex">
                                                <span className="text-faded text-uppercase ">Date</span>
                                                <span className="text-faded text-uppercase ps-3">01.10.22</span>
                                            </div>
                                            <button className="g-btn px-5 mt-2 text-uppercase col-lg-7 col-12">Claim</button>
                                            <div className="d-flex">
                                                <span className="text-faded text-uppercase pt-2">AMOUNT : 10214 YRP</span>
                                            </div>
                                        </div>
                                        <span className="d-lg-none d-flex border-bottom mb-3 col-12"></span>

                                        <div className=" d-flex flex-column align-items-center ps-0 w-100 pb-lg-0 pb-3">
                                            <div className="d-flex">
                                                <span className="text-faded text-uppercase ">Date</span>
                                                <span className="text-faded text-uppercase ps-3">01.10.22</span>
                                            </div>
                                            <button className="g-btn px-5 mt-2 text-uppercase col-lg-7 col-12">Claim</button>
                                            <div className="d-flex">
                                                <span className="text-faded text-uppercase pt-2">AMOUNT : 10214 YRP</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-center flex-column pb-5 mt-5">

                    <div className="w-100 px-0 border-start home-img d-lg-none d-flex align-items-center justify-content-center">
                        <img src={process.env.PUBLIC_URL + '/assets/images/cartoon.png'} className="w-75" alt="" />
                    </div>
                    <h1 className="h1 text-center">How to Participate</h1>
                </div>

                <div className="row mx-0">
                    <div className="col-lg-6 px-0">
                        <div className="row ">
                            <div className="col-12 px-lg-0 px-2 pt-3">
                                <div className="d-flex justify-content-end align-items-center">
                                    <div className="card col-lg-8 col-12 p-3">
                                        <div className="card-body align-items-start">
                                            <div className="h6">Before Sale</div>
                                            <span className="text-faded">Connect your wallet </span>
                                            <button className="g-btn px-4 mt-2 text-uppercase" onClick={() => scrollTopTop(setstate)}>Connect</button>
                                        </div>
                                    </div>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/dot-purple.png"} className="purple-dot-2  d-lg-block d-none" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12 px-lg-0 px-2 pt-lg-3">
                                <div className="d-flex justify-content-end align-items-center">
                                    <div className="card col-lg-8 col-12  p-3">
                                        <div className="card-body align-items-start">
                                            <div className="h6">Before Sale</div>
                                            <span className="text-faded ">Get Busd Token </span>
                                            <Link className="g-btn px-4 mt-2 text-uppercase" to='swap'>Get Busd</Link>
                                        </div>
                                    </div>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/dot-purple.png"} className="purple-dot-2  d-lg-block d-none" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12 px-lg-0 px-2 pt-lg-3">
                                <div className="d-flex justify-content-end align-items-center">
                                    <div className="card g-btn align-items-start text-white text-start col-lg-8 col-12  p-3">
                                        <div className="card-body align-items-start">
                                            <div className="h6">During Sale</div>
                                            <span className="text-light fw-500 " style={{ opacity: ".5", fontWeight: "500" }}>While the sale is live commit your BUSD Tokens to Buy Reaper ( YRP ) Tokens </span>
                                        </div>
                                    </div>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/dot-purple.png"} className="purple-dot-2  d-lg-block d-none" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12 px-lg-0 px-2 pt-lg-3">
                                <div className="d-flex justify-content-end align-items-center">
                                    <div className="card col-lg-8 col-12 p-3">
                                        <div className="card-body align-items-start">
                                            <div className="h6">After Sale</div>
                                            <span className="text-faded fw-600">Get Reaper TRP Token </span>
                                            <span className="text-faded fw-600 pt-4 d-flex align-items-center">  <span className="text-faded fw-600 fs-6 pe-2 ">• </span>  immediately after sale </span>
                                            <button className="btn-faded px-3 py-2  mt-2 text-uppercase" style={{ fontSize: "10px" }}>claim your refund and 25% of your (YRP) tokens</button>
                                            <span className="text-faded fw-600 pt-2 d-flex align-items-center">  <span className="text-faded fw-600 fs-6 pe-2 ">• </span>  30 Days after sale </span>
                                            <button className="btn-faded px-3 py-2  mt-2 text-uppercase" style={{ fontSize: "10px" }}>claim another 25% of your (yrp) tokens</button>
                                            <span className="text-faded fw-600 pt-2 d-flex align-items-center">  <span className="text-faded fw-600 fs-6 pe-2 ">• </span>  60 Days after sale</span>
                                            <button className="btn-faded px-3 py-2  mt-2 text-uppercase" style={{ fontSize: "10px" }}>claim another 25% of your (yrp) tokens</button>
                                            <span className="text-faded fw-600 pt-2 d-flex align-items-center">  <span className="text-faded fw-600 fs-6 pe-2 ">• </span>  90 Days after sale</span>
                                            <button className="btn-faded px-3 py-2  mt-2 text-uppercase" style={{ fontSize: "10px" }}>claim final 25% of your (yrp) tokens</button>
                                        </div>
                                    </div>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/dot-purple.png"} className="purple-dot-2  d-lg-block d-none" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 px-0 border-start home-img d-lg-flex d-none align-items-center justify-content-center">
                        <img src={process.env.PUBLIC_URL + '/assets/images/cartoon.png'} className="w-75" alt="" />
                    </div>
                </div>



                <div className="row mt-5">
                    <h1 className="h1 text-center mb-5 mt-3">Question & Answer</h1>


                    <div className="col-12 p-2">
                        <Accordion defaultActiveKey="0">
                            <Card className="m-0 mb-3 acc-card">
                                <Card.Header className="py-3 d-flex align-items-center">
                                    <ContextAwareToggle eventKey="0">+</ContextAwareToggle>
                                    <div className="mb-0">How to participate in IRO?</div>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body className=""> <span className="ps-lg-5 ps-0" >-Connect your wallet and buy BUSD tokens</span>  </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            <Card className="m-0 mb-3 acc-card">
                                <Card.Header className="py-3 d-flex align-items-center">
                                    <ContextAwareToggle eventKey="1">+</ContextAwareToggle>
                                    <div className="mb-0">What to do during the sale?</div>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body className=""> <span className="ps-lg-5 ps-0" >-While the sale is live,commit your BUSD tokens to buy the REAPER(YRP) tokens.</span>  </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            <Card className="m-0 mb-3 acc-card">
                                <Card.Header className="py-3 d-flex align-items-center">
                                    <ContextAwareToggle eventKey="2">+</ContextAwareToggle>
                                    <div className="mb-0">What to do after the sale?</div>
                                </Card.Header>
                                <Accordion.Collapse eventKey="2">
                                    <Card.Body className="">
                                        <div className="d-flex flex-column w-100 ps-lg-5 ps-0">
                                            <span  >-Immediately after sale:</span>
                                            <span>You may claim your refund and 25% of your REAPER(YRP) tokens</span>
                                            <span> 30 days after sale: You may claim another 25% of your REAPER(YRP) tokens</span>
                                            <span> 60 days after sale: You may claim another 25% of your REAPER(YRP) tokens</span>
                                            <span> 90 days after sale: You may claim the final 25% of your REAPER(YRP) tokens</span>
                                        </div>

                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            <Card className="m-0 mb-3 acc-card">
                                <Card.Header className="py-3 d-flex align-items-center">
                                    <ContextAwareToggle eventKey="3">+</ContextAwareToggle>
                                    <div className="mb-0">What is the 'overflow' sale method?</div>
                                </Card.Header>
                                <Accordion.Collapse eventKey="3">
                                    <Card.Body className=""> <span className="ps-lg-5 ps-0" >-In the “Overflow” method, users can subscribe as much or as little as they want to the IRO,
                                        and their final allocation will be based on the amount of funds they put in as a percentage
                                        of all funds put in by other users at the time the sale ends.
                                        Users will receive back any leftover funds when they claim their tokens after the sale.</span>  </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            <Card className="m-0 mb-3 acc-card">
                                <Card.Header className="py-3 d-flex align-items-center">
                                    <ContextAwareToggle eventKey="4">+</ContextAwareToggle>
                                    <div className="mb-0">Why didn't  you do IFO using top AMM exchanges?</div>
                                </Card.Header>
                                <Accordion.Collapse eventKey="4">
                                    <Card.Body className=""> <span className="ps-lg-5 ps-0" >
                                        -Top AMM exchange charge 50% of the price that customers pay.
                                        In this way we reduce inflation and price pressure at the start of the chain.</span>  </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div>
                </div>

            </div>
        </>
    )
}
